import { computed, getCurrentInstance, type Ref } from 'vue';
import { DEFAULT_GRID_ROW_HEIGHT } from '@integro/core';

export { DEFAULT_GRID_ROW_HEIGHT as DEFAULT_ROW_HEIGHT } from '@integro/core';

interface AppGridPreferences {
  rowHeight?: number;
}

export function useGridPreferences() {
  const instance = getCurrentInstance();
  const prefs = (): AppGridPreferences | null =>
    (instance?.proxy as any)?.$app?.preferences?.grid ?? null;

  const configuredRowHeight = computed<number | null>(() => {
    const height = Number(prefs()?.rowHeight);
    return Number.isFinite(height) && height > 0 ? height : null;
  });

  function resolveRowHeight(explicit: Ref<number | undefined>): Ref<number> {
    return computed(
      () =>
        explicit.value ?? configuredRowHeight.value ?? DEFAULT_GRID_ROW_HEIGHT,
    );
  }

  return { configuredRowHeight, resolveRowHeight };
}
